var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { authInstance, restName } from '../firebase';
import { getBackendConfig } from './backends';
export const httpRequestWithToken = ({ url, method, payload, options, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const token = yield ((_a = authInstance.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken());
    const opts = Object.assign(Object.assign({}, options), { auth: { username: restName, password: token } });
    return httpRequest({ url, method, payload, options: opts });
});
export const httpRequest = ({ url, method, payload, options, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c, _d;
    try {
        const res = yield axios(Object.assign({ url,
            method, data: payload }, (options || {})));
        // monkey-patch response object for easier logging
        res.request.url = url;
        res.request.payload = payload;
        res.request.method = method;
        return res;
    }
    catch (err) {
        // Exception may be raised at different points of request lifecycle
        // and we want to monkey-patch the object the same as the
        // regular response above.
        if (err.response) {
            // Http request was made, but server replied with a non-2xx status code
            // (by default, axios raises an exception in such case).
            err.request = { url, method, payload };
            // Backend may send also specific error message embedded in the response json.
            // This can be formatted differently, depending on particular api implementation.
            const { data } = err.response;
            err.message = ((_d = (_c = (_b = data.error) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.message) || data.msg || data.name || err.message;
        }
        else if (err.request) {
            // Http request was made, but no response was received
            err.request.url = url;
            err.request.payload = payload;
            err.request.method = method;
        }
        else {
            // Error happened during request setup or serialization
            err.request = { url, method, payload };
        }
        throw err;
    }
});
export const getAvaBackendEndpoint = () => localStorage.getItem('avaBackendUrl') || getBackendConfig('captionerUrl');
export const getScribeBackendEndpoint = () => localStorage.getItem('scribeBackendUrl') || getBackendConfig('scribeUrl');
export const firebaseFunctionsEndpoint = getBackendConfig('firebaseFunctionsEndpoint');
export const cloudTranscriptsEndpoint = `${firebaseFunctionsEndpoint}/widgets/cloudTranscripts`;
export const smartRecapEndpoint = `${firebaseFunctionsEndpoint}/generateSmartRecap`;
export const getSubscriptionBackendEndpoint = () => getBackendConfig('subscriptionUrl');
export const getSaasBackendEndpoint = () => localStorage.getItem('saasBackendUrl') || getBackendConfig('saasUrl');
export const getSearchValueFromString = (searchString, key, _default) => {
    if (!searchString) {
        return _default;
    }
    const params = new URLSearchParams(searchString);
    return params.get(key) || _default;
};
export const getSearchValue = (window, key, _default = undefined) => {
    // I don't know why, but window.location can sometimes be undefined. This looks
    // like browser bug, but even when window.location is undefined,
    // document.location is set.
    const location = window.location || document.location;
    const searchString = location.search;
    return getSearchValueFromString(searchString, key, _default);
};
export const setSearchValue = (window, key, value) => {
    const location = window.location || document.location;
    const url = new URL(location.href);
    const oldUrlString = url.toString();
    const params = new URLSearchParams(url.search);
    params.set(key, value);
    url.search = params.toString();
    const newUrlString = url.toString();
    if (oldUrlString !== newUrlString) {
        window.history.replaceState(null, '', newUrlString);
    }
};
export const clearSearchValue = (window, key) => {
    const location = window.location || document.location;
    const url = new URL(location.href);
    const oldUrlString = url.toString();
    const params = new URLSearchParams(url.search);
    params.delete(key);
    url.search = params.toString();
    const newUrlString = url.toString();
    if (oldUrlString !== newUrlString) {
        window.history.replaceState(null, '', newUrlString);
    }
};
const initBackend = getSearchValue(window, 'endpoint', undefined);
if (initBackend && initBackend.endsWith('ava.me')) {
    const url = new URL(initBackend);
    if (url.hostname.endsWith('ava.me')) {
        localStorage.setItem('avaBackendUrl', initBackend);
    }
}
export const updateBackendAva = (backendId, backendsAva) => {
    localStorage.setItem('avaBackendUrl', backendsAva[backendId].url);
    window.location.replace('/');
};
